import React from "react";
import { Link } from "react-router-dom";

import { Symbol } from "@atsent/components";

import "./SideNLogo.scss";

export type SideNLogoProps = {
  cx: string;
};

export const SideNLogo: React.FC<SideNLogoProps> = ({ cx, children }) => {
  return (
    <div className={`SideNLogo`}>
      <Link to={"/"} className="symbol-wrapper">
        <Symbol />
      </Link>
      <header />
      <aside />
      <main className={cx}>{children}</main>
    </div>
  );
};
